import { InjectionToken, inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from '@services/confirmation';

export interface PageHasChanges {
  hasPendingChanges(): boolean;
  discardChanges(): void;
}

export const PAGE_HAS_CHANGES = new InjectionToken<PageHasChanges>('PAGE_HAS_CHANGES');

export const pageHasChangesGuard: CanDeactivateFn<PageHasChanges> = (component) =>
  confirmDiscardPageChangesAsync(component);

export async function confirmDiscardPageChangesAsync(component: PageHasChanges): Promise<boolean> {
  if (!component.hasPendingChanges()) {
    return true;
  }

  const confirmationService = inject(ConfirmationService);
  const translate = inject(TranslateService);

  const confirmed = await confirmationService.confirm({
    title: translate.instant('general.unsavedChanges.title'),
    subtitle: translate.instant('general.unsavedChanges.subtitle'),
    message: translate.instant('general.unsavedChanges.message'),
    okText: translate.instant('general.unsavedChanges.leave'),
    cancelText: translate.instant('general.cancel')
  });

  if (confirmed) {
    component.discardChanges();
  }
  return confirmed;
}
